import { Strings } from '@/constants/strings';

const STORAGE_KEY = 'kalpEgitim_userAgreed';

export function getUserAgreed(): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export function setUserAgreed(): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, 'true');
  }
}

interface UserAgreementModalProps {
  visible: boolean;
  onAccept: () => void;
}

export function UserAgreementModal({ visible, onAccept }: UserAgreementModalProps) {
  if (!visible) return null;

  const handleAccept = () => {
    setUserAgreed();
    onAccept();
  };

  return (
    <div
      className="animate-modal-backdrop fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="user-agreement-title"
    >
      <div className="animate-modal-content relative flex max-h-[90vh] w-full max-w-md flex-col rounded-3xl bg-white/90 shadow-xl backdrop-blur-lg">
        <div className="shrink-0 border-b border-border px-4 py-3">
          <h2 id="user-agreement-title" className="text-lg font-bold text-[#1A1A1A]">
            {Strings.userAgreementTitle}
          </h2>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
          <p className="text-sm leading-relaxed text-[#1A1A1A]">
            {Strings.userAgreementText}
          </p>
        </div>
        <div className="shrink-0 border-t border-border px-4 py-4">
          <button
            type="button"
            onClick={handleAccept}
            className="w-full rounded-xl bg-primary py-3.5 text-base font-bold text-[#FFFFFF] transition hover:bg-primary-active active:bg-primary-active"
          >
            {Strings.userAgreementButton}
          </button>
        </div>
      </div>
    </div>
  );
}
